import { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useParams } from 'react-router';
import { UserContext } from '../../../helper/ProtectedRoute';
import { roleHandler } from '../../../helper/roleHandler';
import { ChevronRight } from 'lucide-react';
import CodPayables from './CodPayables';
import BankCharges from './BankCharges';
import CodArchive from './CodArchive';
import '../../Crm/Customers/styles/customer-tabs.scss';

const CodTabs = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [tab, setTab] = useState(1);
  const prevent = useRef(false);
  const [editPage, setEditPage] = useState(false);
  const tabHandler = (i) => {
    prevent.current = false;
    setEditPage(false);
    setTab(i);
  };
  const [state] = useContext(UserContext);
  const [role, setRole] = useState(sessionStorage.getItem('user_access_role'));
  useEffect(() => {
    setRole(state.roles);
  }, [state.roles]);

  const canViewGenerateCod =
    roleHandler(role, 'AONE_FINANCE_COD.admin') ||
    roleHandler(role, 'AONE_FINANCE_COD_PAYABLE.read') ||
    roleHandler(role, 'AONE_FINANCE_COD_PAYABLE.write');

  const canViewCodArchive =
    roleHandler(role, 'AONE_FINANCE_COD.admin') ||
    roleHandler(role, 'AONE_FINANCE_COD_ARCHIVE.read') ||
    roleHandler(role, 'AONE_FINANCE_COD_SEND_EMAIL.write');

  const canViewBankCharges =
    roleHandler(role, 'AONE_FINANCE_COD.admin') ||
    roleHandler(role, 'AONE_FINANCE_COD_BANK-CHARGES.write');

  useEffect(() => {
    const firstAllowedTab = canViewGenerateCod ? 1 : canViewCodArchive ? 2 : canViewBankCharges ? 3 : 1;
    if (
      (tab === 1 && !canViewGenerateCod) ||
      (tab === 2 && !canViewCodArchive) ||
      (tab === 3 && !canViewBankCharges)
    ) {
      setTab(firstAllowedTab);
    }
  }, [tab, canViewGenerateCod, canViewCodArchive, canViewBankCharges]);

  const tabLabels = { 1: 'GENERATE COD', 2: 'COD ARCHIVE SUMMARY', 3: 'BANK CHARGES' };

  return (
    <div className="flex-1 overflow-auto bg-gray-50 -m-3 font-sans">
      <div className="address-breadcrumb-bar">
        <div className="address-breadcrumb-content">
          <span className="address-breadcrumb-link">FINANCE</span>
          <ChevronRight className="address-breadcrumb-separator" />
          <span className="address-breadcrumb-link">COD</span>
          <ChevronRight className="address-breadcrumb-separator" />
          <span className="address-breadcrumb-current">{tabLabels[tab]}</span>
        </div>
      </div>
      <div className="customer-tabs">
        <div className="tabs-container">
          {canViewGenerateCod && (
            <button
              className={`tab-button ${tab === 1 ? 'active' : ''}`}
              onClick={() => tabHandler(1)}
            >
              Generate COD
            </button>
          )}
          {canViewCodArchive && (
            <button
              className={`tab-button ${tab === 2 ? 'active' : ''}`}
              onClick={() => tabHandler(2)}
            >
              COD Archive Summary
            </button>
          )}
          {canViewBankCharges && (
            <button
              className={`tab-button ${tab === 3 ? 'active' : ''}`}
              onClick={() => tabHandler(3)}
            >
              Bank Charges
            </button>
          )}
        </div>
      </div>
      <div className="tab-content-area">
        {tab === 1 && canViewGenerateCod ? (
          <CodPayables tab={tab} setTab={setTab} />
        ) : tab === 2 && canViewCodArchive ? (
          <CodArchive tab={tab} setTab={setTab} />
        ) : tab === 3 && canViewBankCharges ? (
          <BankCharges tab={tab} setTab={setTab} />
        ) : null}
      </div>
    </div>
  );
};

export default CodTabs;